import React from "react";
import Select from "react-select";

// Se usa forwardRef porque react-hook-form pasa un ref al esparcir `field`.
// Sin esto React avisaba "Function components cannot be given refs" y, más
// importante, el formulario no podía enfocar el campo al fallar la validación.
const RSelect = React.forwardRef(({ ...props }, ref) => {
  return (
    <div className="form-control-select">
      <Select
        ref={ref}
        className={`react-select-container ${props.className ? props.className : ""}`}
        classNamePrefix="react-select"
        {...props}
      />
    </div>
  );
});

RSelect.displayName = "RSelect";

export default RSelect;
